import { supabase } from './supabaseClient'

export const submitFeedback = async (userId: string, message: string) => {
  const { error } = await supabase
    .from('feedback')
    .insert({ user_id: userId, message })
  if (error) throw error
}
